import { PositionStatus } from "../constants";
import { IsPositionChart } from "./IsPositionChart";

export function CreateFieldSourceMaps(metadata) {
  if (!metadata || typeof metadata !== "object") {
    return {
      holders: {
        append: [],
        merge: []
      },
      positions: {
        append: [],
        merge: []
      }
    };
  }

  const initialFieldSources = createInitialFieldSources(metadata);

  if (IsPositionChart(metadata)) {
    return createFieldSourcesWithPosition(metadata, initialFieldSources);
  } else {
    return {
      holders: {
        append: initialFieldSources.append,
        merge: initialFieldSources.merge
      },
      positions: {
        append: [],
        merge: []
      }
    };
  }
}

function createInitialFieldSources(metadata) {
  const importFieldSources = new Set();

  // Process 'import' section first
  if (metadata["import"] && Array.isArray(metadata["import"].headers)) {
    const importHeaders = metadata["import"].headers;
    importHeaders.forEach(importFieldSources.add, importFieldSources);
  }

  const appendFieldSources =
    metadata["append"] && Array.isArray(metadata["append"])
      ? metadata["append"].map(appendSource => ({
          source: appendSource.source,
          override: appendSource.override,
          datadir: appendSource.datadir,
          datafile: appendSource.datafile,
          keys: Array.isArray(appendSource.headers)
            ? new Set(appendSource.headers.filter(header => !importFieldSources.has(header)))
            : new Set()
        }))
      : [];

  const mergeFieldSources =
    metadata["merge"] && Array.isArray(metadata["merge"])
      ? metadata["merge"].map(mergeSource => ({
          source: mergeSource.source,
          datadir: mergeSource.datadir,
          datafile: mergeSource.datafile,
          keys: Array.isArray(mergeSource.headers)
            ? new Set(mergeSource.headers.filter(header => !importFieldSources.has(header)))
            : new Set()
        }))
      : [];

  return {
    append: appendFieldSources,
    merge: mergeFieldSources
  };
}

function createFieldSourcesWithPosition(metadata, fieldSources) {
  const holderFields = new Set(
    metadata["holderFields"] && Array.isArray(metadata["holderFields"])
      ? metadata["holderFields"]
      : []
  );
  const positionFields = new Set(
    metadata["positionFields"] && Array.isArray(metadata["positionFields"])
      ? metadata["positionFields"]
      : []
  );

  return {
    holders: {
      append: filterSourcesByFields(fieldSources.append, holderFields),
      merge: filterSourcesByFields(fieldSources.merge, holderFields)
    },
    positions: {
      append: filterSourcesByFields(fieldSources.append, positionFields),
      merge: filterSourcesByFields(fieldSources.merge, positionFields)
    }
  };
}

// Helper to filter sources by relevant fields
function filterSourcesByFields(sources, fields) {
  return sources
    .map(source => {
      const filteredKeys = new Set([...source.keys].filter(key => fields.has(key)));
      return { ...source, keys: filteredKeys };
    })
    .filter(source => source.keys.size > 0);
}
